export const timelineData = [
  {
    id: 'education',
    company: 'Universidad de Cartagena',
    position: 'Software Engineer',
    date: '2013 - 2017',
    content: {
      summary: 'Scientific and engineering aspects of computing, including programming, algorithms and data structures, computer architecture, database systems, computer simulations and data science.',
      details: null
    }
  },
  {
    id: 'fleks',
    company: 'Fleks',
    position: 'Product Owner, on-site in Amsterdam, Holland',
    date: 'March 2018 - February 2019',
    content: {
      summary: 'When I joined Fleks, a B2B SaaS startup for job agencies, the founders were down to their last €20K. Here\'s how I played a crucial role in their survival:',
      details: [
        'Replaced a €50/hr software house with €12/hr Colombian talent, extending runway from 2 to 8+ months while improving output quality.',
        'Guided the team to reduce API response times from 30+ to under 2 seconds.',
        'Delivered a seamless user flow enabling growth from dozens to hundreds of users in the first year.'
      ]
    }
  },
  {
    id: 'elemento43',
    company: 'Elemento 43',
    position: 'Product Manager, hybrid from Colombia',
    date: 'March 2019 - May 2022',
    content: {
      summary: 'Led a team of 40+ developers for three B2B products in the Netherlands, focusing on strategic planning, execution, and optimization. Took products from 0 to 1 and scaled them for increased performance and user satisfaction.',
      details: [
        'Automated data collection for an elevator auditing startup, reducing report generation from 5+ days to seconds. Increased client onboarding by 50% in under a year.',
        'Rebuilt a school payment platform\'s architecture, enabling acquisition and expansion from 150 to 2K schools, increasing monthly payments from 200K to over 3M.',
        'Led migration of a financial reconciliation platform from monolithic to microservices architecture, expanding capacity from 2M to 7M monthly transactions.'
      ]
    }
  },
  {
    id: 'publicis',
    company: 'Publicis Sapient',
    position: 'Product Manager, remote from Colombia',
    date: 'June 2022 - October 2024',
    content: {
      summary: 'Led cross-functional teams to deliver product improvements and streamline processes across healthcare, and oil & gas sectors, focusing on efficiency, automation, and user satisfaction.',
      details: [
        'Healthcare: Led the development of AI-driven solutions by integrating LLMs, saving 1,200+ manual work hours per month through automation.',
        'Oil & Gas: Directed the implementation of a new security framework, reducing approval times by 82% and improving system integrity.'
      ]
    }
  },
  {
    id: 'trustshoring',
    company: 'Trustshoring',
    position: 'Sr Product Manager, remote from Colombia',
    date: 'November 2024 - Present',
    content: {
      summary: 'When I joined, the team was stuck in an inefficient system with endless approval steps, and frustrated stakeholders. They were ready to cut the budget down to maintenance mode. I changed the entire delivery process by introducing refinement, and estimation sessions using Fibonacci points, unblocking the pipeline and giving the team clarity.',
      details: 'As a result, stakeholders tripled the product budget. The team hit its highest productivity ever, and for the first time, we could measure throughput, velocity, and hours per point, allowing for predictability to planning, based on historical data, not gut feeling.'
    }
  }
];